import React from 'react';
import { useTheme } from '../context/ThemeContext';

function Modal({ isOpen, onClose, children }) {
  const { isDark } = useTheme();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className={`fixed inset-0 transition-opacity ${isDark ? 'bg-hack-primary bg-opacity-75' : 'bg-black bg-opacity-50'}`}
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="flex min-h-screen items-center justify-center p-4">
        <div 
          className={`relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:w-full sm:max-w-2xl ${isDark 
            ? 'bg-hack-secondary' 
            : 'bg-white'}`}
        >
          {/* Close button */}
          <button
            onClick={onClose}
            className={`absolute right-4 top-4 transition-colors ${isDark 
              ? 'text-gray-400 hover:text-white' 
              : 'text-gray-500 hover:text-gray-900'}`}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Content */}
          <div className="p-6">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
